import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTiktok, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

// Import Css
import './socialMediaComponents.css';


export function SocialMediaComponents() {

  return (

    <div className="box-social-media-components">

        <a className="icon-social-media icon-fb" href="https://www.facebook.com/monitronixEc/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebookF}/>
        </a>

        <a className="icon-social-media icon-tk" href="https://www.tiktok.com/@monitronixec" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTiktok}/>
        </a>

        <a className="icon-social-media icon-Ins" href="https://www.instagram.com/monitronixec/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram}/>
        </a>

        <a className="icon-social-media icon-Wts" href="https://wa.me/593967124133" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faWhatsapp}/>        
        </a>
        
    </div>

  );

}
